import { Button, Tooltip, useComputedColorScheme } from '@mantine/core';
import { IconRefresh } from '@tabler/icons-react';
import { QueryClient } from '@tanstack/react-query';

interface InternalRefreshButtonProps {
  queryClient: QueryClient;
}

export const InternalRefreshButton: React.FC<InternalRefreshButtonProps> = ({
  queryClient,
}) => {
  const toolbarIconSize = 24;
  const toolbarButtonSize = 32;
  const computedColorScheme = useComputedColorScheme('dark');
  return (
    <Tooltip label="Refresh Table" position="top">
      <Button
        variant="subtle"
        size="xs"
        p={0}
        style={{
          width: toolbarButtonSize,
          height: toolbarButtonSize,
          minWidth: toolbarButtonSize,
        }}
        onClick={() => queryClient.invalidateQueries()}
        className="internal-refresh-button"
        data-testid="internal-refresh-button"
      >
        <IconRefresh
          size={toolbarIconSize}
          color={computedColorScheme === 'dark' ? 'white' : 'black'}
        />
      </Button>
    </Tooltip>
  );
};
